;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import {
	TIER_WRITE_ACTIONS,
	type TierWriteAction,
} from "@/lib/services/tier/tier-constants";
import { PricingTier } from "@/prisma/generated/enums";

export { TIER_WRITE_ACTIONS, type TierWriteAction };

export interface TierGuardContext {
	pricingTier: PricingTier;
	expiresAt: Date | string | null;
	tierAllowedSystemViewNames?: string[];
}

export function isFreemiumTrialExpired(
	expiresAt: Date | string | null | undefined,
	now: Date = new Date(),
): boolean {
	if (!expiresAt) {
		return false;
	}

	const expiry =
		typeof expiresAt === "string" ? new Date(expiresAt) : expiresAt;
	return expiry.getTime() < now.getTime();
}

export function getActiveFreemiumTrialExpiresAt(
	context: TierGuardContext | null,
	now: Date = new Date(),
): Date | null {
	if (!context) {
		return null;
	}

	if (context.pricingTier !== PricingTier.FREEMIUM) {
		return null;
	}

	if (!context.expiresAt || isFreemiumTrialExpired(context.expiresAt, now)) {
		return null;
	}

	return typeof context.expiresAt === "string"
		? new Date(context.expiresAt)
		: context.expiresAt;
}

/** Effective tier for permission checks (expired Freemium → Standard). */
export function getEffectivePricingTier(
	context: TierGuardContext,
	now: Date = new Date(),
): PricingTier {
	if (
		context.pricingTier === PricingTier.FREEMIUM &&
		isFreemiumTrialExpired(context.expiresAt, now)
	) {
		return PricingTier.STANDARD;
	}

	return context.pricingTier;
}

export function isFreemiumOrPremiumTier(
	context: TierGuardContext,
	now: Date = new Date(),
): boolean {
	const effectiveTier = getEffectivePricingTier(context, now);

	return (
		effectiveTier === PricingTier.FREEMIUM ||
		effectiveTier === PricingTier.PREMIUM
	);
}

export function canPerformTierWrite(
	context: TierGuardContext,
	action: TierWriteAction,
	now: Date = new Date(),
): boolean {
	if (isFreemiumOrPremiumTier(context, now)) {
		return true;
	}

	return action === TIER_WRITE_ACTIONS.inviteMembers;
}

export function isSystemViewAllowedForTier(
	context: TierGuardContext,
	systemViewName: string,
	now: Date = new Date(),
): boolean {
	if (isFreemiumOrPremiumTier(context, now)) {
		return true;
	}

	const allowedNames = context.tierAllowedSystemViewNames ?? [];
	return allowedNames.includes(systemViewName);
}
